import { asyncBundleIndex } from 'Store/dynamicLoading';

import type { DynamicFeaturesState, DynamicLoadingState, DynamicReducersState } from './types';

const dynamicReducers: DynamicReducersState = asyncBundleIndex.reduce((acc, obj) => {
  acc[obj.name] = false;
  return acc;
}, {});

const dynamicFeatures: DynamicFeaturesState = {};

const initialState: DynamicLoadingState = {
  dynamicReducers,
  dynamicFeatures,
};

export default initialState;
